import { render, staticRenderFns } from "./user-items-primary.vue?vue&type=template&id=8a423a8a&scoped=true&"
import script from "./user-items-primary.vue?vue&type=script&lang=js&"
export * from "./user-items-primary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a423a8a",
  null
  
)

export default component.exports